module.exports.CONSOLE_VERSION = '6.7.0.14'
module.exports.WI_CONSOLE_VERSION = '1.3.0.122'
